import { Extraction, SIwaveInfo, HFSSInfo } from './IntegratedChannel';
import { numExponentialFormat } from '@/services/helper/numberHelper';

const SIWAVE_HFSS = "SIwave+HFSS", SIWAVE = 'SIwave', HFSS = 'HFSS';

const defaultExtractionUnit = {
  logSweepMinUnit: 'Hz',
  logSweepMaxUnit: "MHz",
  linearSweepMaxUnit: "GHz",
  linearSweepFreqStepUnit: "MHz",
  maxFreqUnit: "GHz",
  minSolvedFreqUnit: "MHz",
  adaptiveFrequencyUnit: "GHz",
  meshFrequencyUnit: "GHz"
}

function updateExtractionInfo(extraction = {}, designType, serdesType) {
  let newExtraction = {}
  if (!extraction || !Object.keys(extraction)) {
    newExtraction = new Extraction({ designType, serdesType });
  } else {
    newExtraction = JSON.parse(JSON.stringify(extraction))
  }
  const { type, siwave, hfss } = extraction;
  const meshFrequency = numExponentialFormat(Math.min(newExtraction.maxFreq, '5e10'))

  if (type === SIWAVE) {
    newExtraction.siwave = siwave ? siwave : new SIwaveInfo(meshFrequency);
    if (extraction.hybrid) {
      newExtraction.hfss = hfss ? hfss : new HFSSInfo();
    }
  } else {
    newExtraction.hfss = hfss ? hfss : new HFSSInfo(newExtraction.maxPasses, newExtraction.maxDelta, meshFrequency);
  }

  delete newExtraction.maxPasses;
  delete newExtraction.maxDelta;
  return newExtraction
}

function getHybridErrorMsg(hybridRegions = [], extraction = {}) {
  //  Two adjacent regions cannot be set to HFSS at the same time
  let hybridErrorMsg = ''
  if (extraction && extraction.type === "SIwave" && extraction.hybrid && extraction.siwave && extraction.siwave.suggestHFSSRegions) {
    //At this point, suggestHFSSRegions was selected instead of using hybridRegions
    return
  }

  if (extraction && extraction.type === 'SIwave' && extraction.hybrid) {
    if (!hybridRegions.length) {
      hybridErrorMsg = 'HFSS Regions definition cannot be empty.';
    } else if (!hybridRegions.find(item => item.extraction === "HFSS")) {
      hybridErrorMsg = 'HFSS Regions must have at least one region set to "HFSS"'
    }
  }

  for (let i = 0; i < hybridRegions.length; i++) {
    const oneApartNumber = i + 1
    if (oneApartNumber < hybridRegions.length && hybridRegions[i].extraction === 'HFSS' && hybridRegions[oneApartNumber].extraction === 'HFSS') {
      hybridErrorMsg = "Two adjacent regions cannot be set to HFSS at the same time."
    }
  }

  return hybridErrorMsg
}

export {
  updateExtractionInfo,
  getHybridErrorMsg,
  SIWAVE_HFSS,
  SIWAVE,
  HFSS,
  defaultExtractionUnit
}